import { useState, useContext } from 'react';
import { PropTypes } from 'prop-types';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Button } from 'components/UI/Button/Button';
import { DropdownWithMenu } from 'components/UI/DropdownWithMenu/DropdownWithMenu';
import { SearchFilterModal } from 'components/SearchFormAndResults/SearchFormContainer/SearchFilterModal/SearchFilterModal';
import { SearchContext } from 'components/SearchFormAndResults/SearchFormAndResultsProvider';

import './SearchFormFilterControls.scss';

export const SearchFormFilterControls = (props) => {
  const { searchOrderBy } = props;
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const { sortByChangeHandler, searchFilters } = useContext(SearchContext);

  const openFilterModalHandler = () => {
    setModalIsOpen(true);
  };

  const closeFilterModalHandler = () => {
    setModalIsOpen(false);
  };

  return (
    <div className="search-form__filter-controls" data-testid="search-filter-controls">
      <div className="row">
        <div className="col-sm-3 col-md-4 col-lg-3 col-md-offset-2">
          <Button
            extendClass="btn-secondary search-form__filter-button"
            extendTestId="search-filter"
            endIcon={<ArrowDropDownIcon />}
            onClick={openFilterModalHandler}
          >
            Filter results
          </Button>
        </div>
        <SearchFilterModal
          modalIsOpen={modalIsOpen}
          searchFilters={searchFilters}
          closeModalHandler={closeFilterModalHandler}
        />
        <div className="col-sm-3 col-sm-offset-6 col-md-2 col-md-offset-2 col-lg-offset-3">
          <DropdownWithMenu
            defaultValue="Sort by"
            defaultChosenValue="Date"
            disableDefaultItem
            menuData={searchOrderBy}
            dropdownChangeHandler={sortByChangeHandler}
            singleColumn
          />
        </div>
      </div>
    </div>
  );
};

SearchFormFilterControls.propTypes = {
  searchOrderBy: PropTypes.arrayOf(PropTypes.object),
};
